import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { registerUser, apiError, registerUserFailed } from "../../store/actions"

// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import Authentication from "services/Authentication.service"
import ConfirmAccountSection from "components/Authentication/ConfirmAccount"
import PasswordSection from "components/Authentication/CreatePassword"
import CompletedSection from "components/Authentication/RegisterComplete"
import RegisterSection from "components/Authentication/Register"

const authService = new Authentication()

const Register = props => {
  const [regError, setRegError] = useState(false)
  const [regErrorMsg, setRegErrorMsg] = useState("")

  // handleValidSubmit
  const registerUser = (event, values) => {
    //props.registerUser(values)
  }

  const showConfirmOTP = (event, values) => {
    authService.registerUser(values).then(response => {
      if (response.status) {
        handleSection(
          <ConfirmAccountSection
            handleValidSubmit={submitOTP}
            user={response.data}
          />
        )
      } else {
        handleSection(
          <RegisterSection
            handleValidSubmit={showConfirmOTP}
            error={true}
            errorMsg={response.message}
            loading={false}
          />
        )
      }
    })
  }

  const submitOTP = (e, user) => {
    authService.validateOTP(user).then(response => {
      if (response.status) {
        handleSection(
          <PasswordSection
            handleValidSubmit={showPasswordSection}
            user={user}
            error={false}
            errorMsg=""
          />
        )
      } else {
        handleSection(
          <ConfirmAccountSection
            handleValidSubmit={submitOTP}
            user={response}
            error={true}
            errorMsg={response.message}
          />
        )
      }
    })
  }

  const showPasswordSection = (event, values) => {
    authService.createPassword(values).then(response => {
      if (response.status) {
        handleSection(
          <CompletedSection handleValidSubmit={showPasswordSection} />
        )
      } else {
        handleSection(
          <ConfirmAccountSection
            handleValidSubmit={submitOTP}
            user={response}
            error={true}
            errorMsg={response.message}
          />
        )
      }
    })
  }
  const [currentSection, handleSection] = useState(
    <RegisterSection
      handleValidSubmit={showConfirmOTP}
      error={regError}
      errorMsg={regErrorMsg}
    />
  )

  useEffect(() => {
    props.apiError("")
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>Register | REMA</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2"></i>
        </Link>
      </div>
      {currentSection}
    </React.Fragment>
  )
}

Register.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(Register)
